<template>
    <b-modal
      v-model="show"
      size="lg"
      id="createTabModal"
      centered
      hide-footer
      :title="$t('pos_contacts_modal_title')"
      @hidden="clear"
    >
      <b-form class="create-tab-form">
        <Taggregator
          :label="$t('pos_contacts_description_label')"
          ref="addGuestsTags"
          :items="guests"
          :selections.sync="selectedGuestIds"
          :maximum="1"
          :name="'guests'"
          :onAdd="setupTab"
          :quickAddDescription="'Please provide valid first and last names'"
          :quickAddCallback="createGuest"
        />
      </b-form>
    </b-modal>
</template>

<script>
export default {
  name: 'CreateTabModal',
  components: {
    Taggregator: () => import('@/components/Taggregator')
  },

  props: {
    createTab: {
      type: Function,
      required: true,
      default: () => {}
    },
    createGuest: {
      type: Function,
      required: true,
      default: () => {}
    },
    guests: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedGuests: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      selectedGuestIds: this.selectedGuests,
      show: false,
      newGuestName: null
    }
  },

  methods: {
    clear() {
      this.selectedGuestIds = [];
      this.newGuestName = null;
    },
    hide() {
      this.show = false;
    },
    addGuest(newGuest) {
      this.selectedGuestIds.push(newGuest)
    },
    setupTab(newGuest) {
      if (this.selectedGuestIds.indexOf(newGuest.id) === -1) this.addGuest(newGuest)
      this.show = false;
      this.createTab()
    }
  },

  computed: {
    selectableGuests() {
      const guests = this.guests.map(guest => {
        return {
          value: guest.id,
          text: guest.label
        }
      })
      guests.unshift({value: 0, text: 'Create New Guest'})
      return guests
    }
  }
};
</script>

<style lang="scss">
#createTabModal.modal-dialog-centered {
  min-width: 800px;

  .modal-header {
    height: initial;
    width: initial;
  }

  .modal-open {
    margin: auto;
  }
}
</style>
